export default __webpack_public_path__ + "static/media/U.4b6fbd2b.png";